
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { ElForm } from 'element-ui/types/form'
@Component({
  components: { }
})

export default class extends Vue {
  @Prop() readonly trueShow!: boolean
  @Prop() readonly maintainId!: string

  @Watch('trueShow')
  istrue (val: string) {
    if (val) {
      this.formData.maintainId = this.maintainId
    }
  }

  private rules = {
    confirmNotes: [
      { required: true, message: '请输入备注信息', trigger: ['blur', 'change'] }
    ]
  }

  private formData = {
    maintainId: '',
    confirmNotes: ''
  }

  onSubmit () {
    (this.$refs.formData as ElForm).validate(valid => {
      if (valid) {
        this.$axios.post(this.$apis.machineryManage.confirmYhMachineryRepair, this.formData).then(() => {
          this.$message.success('确认成功')
          this.handleClose()
          this.$emit('success')
        })
      }
    })
  }

  handleClose () {
    (this.$refs.formData as ElForm).resetFields()
    this.$emit('update:trueShow', false)
    this.formData = {
      maintainId: '',
      confirmNotes: ''
    }
  }
}
